import { render } from "./NewView.vue?vue&type=template&id=14b18205&scoped=true"
import script from "./NewView.vue?vue&type=script&lang=js"
export * from "./NewView.vue?vue&type=script&lang=js"

import "./NewView.vue?vue&type=style&index=0&id=14b18205&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b18205"]])

export default __exports__